<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="vatTvsFilter === 'vatTvs'"
            variant="outline-secondary"
            @click="updateVatTvsFilter('vatTvs')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="vatTvsFilter === 'vat'"
            variant="outline-primary"
            @click="updateVatTvsFilter('vat')"
        >
            TVA
        </b-button>
        <b-button
            :pressed="vatTvsFilter === 'tvs'"
            variant="outline-primary"
            @click="updateVatTvsFilter('tvs')"
        >
            TVS
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'VatTvsFilter',

    mixins: [DataUpdater],

    computed: {
        ...mapState({
            vatTvsFilter: (state) => state.browsing.vatTvsFilter,
        }),
    },

    methods: {
        updateVatTvsFilter(value) {
            this.$store.commit('browsing/SET_VAT_TVS_FILTER', value)
            this.$root.$refs.vatTable.getItems()
        },
    },
}
</script>

<style scoped></style>
